import script from "./MoleculeLGPD.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoleculeLGPD.vue?vue&type=script&lang=ts&setup=true"

import "./MoleculeLGPD.vue?vue&type=style&index=0&id=41c17c1f&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41c17c1f"]])

export default __exports__